var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    width: 'auto',
    height: '100%',
    overflowY: 'auto',
    overflowX: 'auto'
  }),attrs:{"id":"projectActualCost"}},[_c('div',[_c('add-level',{attrs:{"costBasis":_vm.projectData.costBasis,"assetId":_vm.projectData.assetId,"dropdownData":_vm.dropdownData,"screenIndentifier":_vm.screenIndentifier,"projectData":_vm.projectData},on:{"calculateLevelTotal":_vm.calculateLevelTotal,"setLevels":_vm.setLevels,"downloadTemplate":_vm.downloadTemplate}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }